export default {
  path: "",
  name: "Home",
  component: () => import("../pages/index.vue")
};
